export default {
  '0': 'Success',
  '1': 'Validation failed',
  '2': 'Not scanned',
  '7': 'Parameter validation failed',
  '402': 'Expired',
  '403': 'User cancelled authorization',
  '404': 'Scan succeeded, user not authorized',
  '405': 'User authorized',
  '408': 'Waiting',
  '10000': 'User not logged in',
  '10001': 'User does not exist',
  '10003': 'Invalid username or password',
  '10005': 'Registration failed',
  '10006': 'Email already in use',
  '10007': 'New password is the same as old password',
  '10008': 'Not a member, please register first',
  '10009': 'Passwords do not match',
  '10010': 'Invalid email format',
  '10011': 'User login timeout',
  '10012': 'Incorrect original password',
  '10013': 'Email cannot be empty',
  '10014': 'Password cannot be empty',
  '10015': 'Expired',
  '10016': 'Verification code exceeded 5 attempts',
  '10017': 'Incorrect verification code',
  '10020': 'User frozen or cancelled',
  '10021': 'Phone number must not exceed 20 characters',
  '10022': 'Email must not exceed 50 characters',
  '10023': 'Nickname must not exceed 50 characters',
  '10024': 'Username must not exceed 50 characters',
  '10025': 'Password must not exceed 20 characters',
  '10026': 'Platform parameter error',
  '10029': 'Verification code cannot be empty',
  '10031': 'Account temporarily disabled due to frequent operations',
  '10036': 'Invalid phone or email format',
  '10037': 'Failed to save verification code',
  '10045': 'Phone number already in use',
  '10047': 'Email is not bound',
  '10048': 'Phone is not bound',
  '10050': 'Username too long',
  '10056': 'Nickname contains sensitive words',
  '10101': 'WeChat authorization expired',
  '10103': 'Failed to get WeChat user info',
  '10104': 'Account already bound to WeChat',
  '10106': 'Account already in use',
  '20002': 'Exceeded verification code sending attempts',
  '20004': 'Already verified, no need to repeat',
  '20005': 'Verification code error: Please enter the code you used for successful verification',
}
